import React, { useMemo, useEffect } from 'react';
import { MapContainer, TileLayer, Polygon, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

function FitBounds({ latlngs }) {

  const map = useMap();
  useEffect(() => {
    if (latlngs?.length > 1) {
      try {
        map.fitBounds(L.latLngBounds(latlngs), { padding: [6, 6], animate: false });
      } catch { }
    }
  }, [map, latlngs]);
  return null;
}

// path format from API: "[{longitude: x, latitude: y}, ...]"
export default function PlotMiniMap({ path, height = 90, activeCrop = false }) {
  const latlngs = useMemo(() => {
    try {
      const points = typeof path === 'string' ? JSON.parse(path) : path;
      return (points || []).map((p) => [p.latitude, p.longitude]);
    } catch {
      return [];
    }
  }, [path]);

  if (latlngs.length < 3) return null;

  const centerLat = latlngs.reduce((s, p) => s + p[0], 0) / latlngs.length;
  const centerLng = latlngs.reduce((s, p) => s + p[1], 0) / latlngs.length;

  return (
    <div style={{ width: 160, height, borderRadius: 6, overflow: 'hidden', border: '1px solid #d9d9d9' }}>
      <MapContainer
        center={[centerLat, centerLng]}
        zoom={14}
        style={{ height: '100%', width: '100%' }}
        zoomControl={false}
        scrollWheelZoom={false}
        dragging={false}
        touchZoom={false}
        doubleClickZoom={false}
        attributionControl={false}
      >
        <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" />
        <Polygon positions={latlngs} pathOptions={{ color: '#ffffff', weight: 2, fillColor: activeCrop ? '#52c41a' : '#8B4513', fillOpacity: 0.5 }} />
        <FitBounds latlngs={latlngs} />
      </MapContainer>
    </div>
  );
}
